import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
import '../styles/styling.css';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "styling"
    }}>{`Styling`}</h1>
    <h4 {...{
      "id": "almost-every-element-in-react-elastic-carousel-has-a-css-class-with-the-rec--prefix-rec-is-short-react-elastic-carousel"
    }}>{`Almost every element in `}<inlineCode parentName="h4">{`react-elastic-carousel`}</inlineCode>{` has a css class with the `}<inlineCode parentName="h4">{`rec-`}</inlineCode>{` prefix (rec is short React Elastic Carousel).`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`/* square buttons */
.rec.rec-arrow {
    border-radius: 0;
}

/* round buttons on hover */
.rec.rec-arrow:hover {
    border-radius: 50%;
}

/* hide disabled buttons */
.rec.rec-arrow:disabled {
    visibility: hidden;
}

/* disable default outline on focused items */
/* add custom outline on focused items */
.rec-carousel-item:focus {
    outline: none;
    box-shadow: inset 0 0 1px 1px lightgrey;
}
`}</code></pre>
    <Playground __position={0} __code={'<div className=\"styling-example\">\n  <Carousel itemsToShow={2}>\n    <Item>1</Item>\n    <Item>2</Item>\n    <Item>3</Item>\n    <Item>4</Item>\n    <Item>5</Item>\n    <Item>6</Item>\n  </Carousel>\n</div>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div className="styling-example">
        <Carousel itemsToShow={2} mdxType="Carousel">
            <Item mdxType="Item">1</Item>
            <Item mdxType="Item">2</Item>
            <Item mdxType="Item">3</Item>
            <Item mdxType="Item">4</Item>
            <Item mdxType="Item">5</Item>
            <Item mdxType="Item">6</Item>
        </Carousel>
    </div>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      